function stringInterpolation(str, ...args) {
  if (str) {
    let i = 0;
    return str.replace(/%s/g, () => {
      i += 1;
      const element = args[i - 1];
      if (typeof element === 'number') {
        return element;
      }
      return element || '';
    });
  }
  return '';
}

export default stringInterpolation;
